import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { NgxsModule } from '@ngxs/store';

import {
  CanActivateChildFeatureGuard,
  CanActivateFeatureGuard,
  CanLoadFeatureGuard,
} from './guards';
import { FeatureToggleDirective } from './directives';
import { FeatureState } from './state/feature.state';

@NgModule({
  imports: [CommonModule, NgxsModule.forFeature([FeatureState])],
  declarations: [FeatureToggleDirective],
  exports: [FeatureToggleDirective],
})
export class FeatureToggleModule {
  static forRoot(): ModuleWithProviders<FeatureToggleModule> {
    return {
      ngModule: FeatureToggleModule,
      providers: [
        CanLoadFeatureGuard,
        CanActivateFeatureGuard,
        CanActivateChildFeatureGuard,
      ],
    };
  }

  static forChild(): ModuleWithProviders<FeatureToggleModule> {
    return {
      ngModule: FeatureToggleModule,
    };
  }
}
